import React from 'react';

interface IBreakdownPattern {
    title: string;
    score: number;
    color: string;
};
export const BreakdownPatterns = () => {
    const data: IBreakdownPattern[] = [
        {
            title: 'Communication drops during pushback',
            score: 42,
            color: '#FB867E',
        },
        {
            title: 'Data-first responses reduce buy-in',
            score: 38,
            color: '#FFBE7C',
        },
        {
            title: 'Immediate correction triggers defensiveness',
            score: 31,
            color: '#FFBE7C',
        },
    ];

    return (
        <div className='card card--md card--radius-sm dashboard__stats_card__mbts__breakdown_patterns'>
            <p className='text-medium'>Common Breakdown Patterns</p>
            <div className="dashboard__stats_card__mbts__breakdown_patterns__content">
                <div className="dashboard__stats_card__mbts__breakdown_patterns__list">
                    {data.map((item) => (
                        <div key={item.title} className="dashboard__stats_card__mbts__breakdown_patterns__list__item">
                            <p className="text-sm text-medium">{item.title}</p>
                            <div className="dashboard__stats_card__mbts__breakdown_patterns__list__item__score_bar">
                                <div
                                    className="dashboard__stats_card__mbts__breakdown_patterns__list__item__score_bar__fill"
                                    style={{ width: `${item.score}%`, backgroundColor: item.color }}
                                />
                            </div>
                            <p className="text-sm text-bold">{item.score}%</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};